module.exports = __webpack_public_path__ + "static/media/PHCS_logo2.a03b4a47.png";